const development_tenant = {
    notification: 'Estás en modo de desarrollo',
};
export default Object.freeze(development_tenant);
